<div class="card main-food-orders-card container-fluid">
  <div class="row justify-content-between align-items-center module-header mb-4">
    <div class="col-auto">
      <h3 class="module-title m-0">{{ titulo }}</h3>
      <p class="module-subtitle m-0">Gestión de pedidos y cambios de estado en tiempo real</p>
    </div>
    <div class="col-auto d-flex align-items-center gap-2">
      <p-tag
        [value]="storeIsOpen ? 'Negocio Abierto' : 'Negocio Cerrado'"
        [severity]="storeIsOpen ? 'success' : 'secondary'"
      ></p-tag>
      <p-button
        *ngIf="!storeIsOpen"
        label="Abrir negocio"
        icon="pi pi-play"
        severity="success"
        [loading]="togglingStore"
        (onClick)="abrirTienda()"
      />
      <p-button
        *ngIf="storeIsOpen"
        label="Cerrar negocio"
        icon="pi pi-stop-circle"
        severity="danger"
        [outlined]="true"
        [loading]="togglingStore"
        (onClick)="cerrarTienda()"
      />
    </div>
    <div class="col-auto d-flex align-items-center gap-3 flex-wrap">
      <ng-container [ngSwitch]="connectionStatus$ | async">
        <p-tag *ngSwitchCase="'connected'" severity="success" value="En vivo"></p-tag>
        <p-tag *ngSwitchCase="'reconnecting'" severity="warning" value="Reconectando…"></p-tag>
        <p-tag *ngSwitchDefault severity="danger" value="Sin conexión en tiempo real"></p-tag>
      </ng-container>
      <p-button
        [rounded]="true"
        icon="pi pi-refresh"
        severity="secondary"
        [text]="true"
        pTooltip="Actualizar Lista"
        (onClick)="refresh()"
      />
    </div>
  </div>

  <div class="board">
    <section class="board-column board-column--pending">
      <header class="board-column-header">
        <h4 class="board-column-title">Pedidos</h4>
        <span class="board-column-count">{{ pendingOrders.length }}</span>
      </header>
      <div class="board-column-body">
        <ng-container *ngFor="let order of pendingOrders; trackBy: trackByOrderId">
          <ng-container *ngTemplateOutlet="orderCard; context: { $implicit: order }"></ng-container>
        </ng-container>
        <p class="orders-empty" *ngIf="!pendingOrders.length">No hay pedidos nuevos</p>
      </div>
    </section>

    <section class="board-column board-column--preparing">
      <header class="board-column-header">
        <h4 class="board-column-title">Preparando</h4>
        <span class="board-column-count">{{ preparingOrders.length }}</span>
      </header>
      <div class="board-column-body">
        <ng-container *ngFor="let order of preparingOrders; trackBy: trackByOrderId">
          <ng-container *ngTemplateOutlet="orderCard; context: { $implicit: order }"></ng-container>
        </ng-container>
        <p class="orders-empty" *ngIf="!preparingOrders.length">No hay pedidos en preparación</p>
      </div>
    </section>

    <section class="board-column board-column--ready">
      <header class="board-column-header">
        <h4 class="board-column-title">Listos</h4>
        <span class="board-column-count">{{ readyOrders.length }}</span>
      </header>
      <div class="board-column-body">
        <ng-container *ngFor="let order of readyOrders; trackBy: trackByOrderId">
          <ng-container *ngTemplateOutlet="orderCard; context: { $implicit: order }"></ng-container>
        </ng-container>
        <p class="orders-empty" *ngIf="!readyOrders.length">No hay pedidos listos</p>
      </div>
    </section>
  </div>

  <ng-template #orderCard let-order>
    <div class="order-card" [class.order-card--pending]="order.statusId === 1">
      <div class="order-card-top">
        <span class="order-card-id">{{ formatOrderCode(order.orderId) }}</span>
        <span class="order-card-time"><i class="pi pi-clock"></i>{{ order.createdAt | date: 'HH:mm' }}</span>
      </div>
      <div class="order-card-status">
        <span
          *ngIf="order.statusId === 1; else statusTag"
          class="order-card-countdown-chip"
          [class.order-card-countdown-chip--expired]="isCountdownExpired(order)"
        >
          <i [class]="isCountdownExpired(order) ? 'pi pi-exclamation-triangle' : 'pi pi-stopwatch'"></i>
          <span>{{ isCountdownExpired(order) ? 'Tiempo agotado' : getCountdownText(order) }}</span>
        </span>
        <ng-template #statusTag>
          <p-tag [value]="statusLabel(order)" [style]="{ 'background-color': getStatusConfig(order)?.color }"></p-tag>
        </ng-template>
      </div>
      <div class="order-card-customer">{{ order.customerName }}</div>
      <div class="order-card-date">
        {{ order.createdAt | date: 'dd/MM/yyyy' }}
        <ng-container *ngIf="order.items?.length"> · {{ order.items.length }} {{ order.items.length === 1 ? 'ítem' : 'ítems' }}</ng-container>
      </div>
      <div class="order-card-total">
        <span>Total</span>
        <strong>{{ order.total | currency }}</strong>
      </div>
      <div class="order-card-actions">
        <p-button
          *ngIf="primaryActionFor(order) as primary"
          [label]="primary.label"
          [icon]="primary.icon"
          styleClass="w-100"
          (onClick)="updateStatus(order, primary)"
        />
        <div class="order-card-actions-row">
          <p-button
            label="Ver detalles"
            [outlined]="true"
            styleClass="w-100"
            class="order-card-actions-main"
            (onClick)="openDetail(order)"
          />
          <p-button
            *ngFor="let action of secondaryActionsFor(order)"
            [icon]="action.icon"
            [outlined]="true"
            severity="danger"
            [pTooltip]="action.label"
            (onClick)="updateStatus(order, action)"
          />
        </div>
      </div>
    </div>
  </ng-template>

  <p-dialog
    [(visible)]="showDetailDialog"
    [header]="'Pedido ' + (selectedSummaryOrder ? formatOrderCode(selectedSummaryOrder.orderId) : '')"
    [modal]="true"
    [style]="{ width: '32vw' }"
    [breakpoints]="{ '960px': '80vw', '640px': '95vw' }"
    (onHide)="closeDetail()"
  >
    <div *ngIf="selectedSummaryOrder as order" class="detail-body">
      <div class="detail-customer">
        <div class="cell-with-icon">
          <span class="icon-badge icon-badge--user"><i class="pi pi-user"></i></span>
          <span><strong>{{ order.customerName }}</strong></span>
        </div>
        <div class="cell-with-icon">
          <span class="icon-badge icon-badge--phone"><i class="pi pi-phone"></i></span>
          <span>{{ order.customerPhone }}</span>
        </div>
      </div>

      <h5 class="detail-products-title">Productos</h5>
      <div class="detail-product-row" *ngFor="let item of order.items">
        <img
          *ngIf="item.pro_image_url; else noProductImage"
          class="product-thumb"
          [src]="item.pro_image_url"
          [alt]="item.productName"
          loading="lazy"
          (error)="item.pro_image_url = ''"
        />
        <ng-template #noProductImage>
          <span class="product-thumb product-thumb--empty"><i class="pi pi-image"></i></span>
        </ng-template>
        <div class="detail-product-name">
          <span>{{ item.quantity }}× {{ item.productName }}</span>
          <span class="text-muted">{{ item.unitPrice | currency }} c/u</span>
        </div>
        <strong>{{ item.subtotal | currency }}</strong>
      </div>

      <div class="detail-totals">
        <div class="detail-totals-row"><span>Subtotal</span><span>{{ order.subtotal | currency }}</span></div>
        <div class="detail-totals-row"><span>Envío</span><span>{{ order.deliveryFee | currency }}</span></div>
        <div class="detail-totals-row detail-totals-total"><span>Total</span><span>{{ order.total | currency }}</span></div>
      </div>
    </div>

    <ng-template pTemplate="footer">
      <p-button
        *ngFor="let action of actionsFor(selectedSummaryOrder)"
        [icon]="action.icon"
        [label]="action.label"
        [outlined]="true"
        [severity]="action.confirm ? 'danger' : 'primary'"
        (onClick)="updateStatus(selectedSummaryOrder, action)"
      />
    </ng-template>
  </p-dialog>

  <p-dialog
    [(visible)]="showRejectDialog"
    [header]="'Rechazar pedido ' + (orderToReject ? formatOrderCode(orderToReject.orderId) : '')"
    [modal]="true"
    [style]="{ width: '30vw' }"
    [breakpoints]="{ '960px': '75vw', '640px': '90vw' }"
  >
    <label for="rejectComment" class="form-label">Motivo del rechazo *</label>
    <textarea
      id="rejectComment"
      pInputTextarea
      rows="3"
      class="w-100"
      [(ngModel)]="rejectComment"
      placeholder="Ej: No tenemos el producto disponible"
    ></textarea>

    <ng-template pTemplate="footer">
      <p-button label="Cancelar" severity="secondary" (onClick)="cancelReject()" />
      <p-button label="Rechazar" severity="danger" [disabled]="!rejectComment.trim()" (onClick)="confirmReject()" />
    </ng-template>
  </p-dialog>
</div>
